import { IObjectKeys } from '../common';

/**
 * Transform Object or Array to CamelCase
 * @param o target
 * @returns transformation result
 */
export function toCamelCase(o: any): any {
  let newO: IObjectKeys;
  var origKey, newKey, value;

  if (o instanceof Array) {
    return o.map(function (value) {
      if (typeof value === 'object') {
        value = toCamelCase(value);
      }
      return value;
    });
  } else {
    newO = {};
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
        value = o[origKey];
        if (value instanceof Array || (value !== null && value !== undefined && value.constructor === Object)) {
          value = toCamelCase(value);
        }
        newO[newKey] = value;
      }
    }
  }

  return newO;
}

/**
 * Transform Object or Array to PascalCase
 * @param o target
 * @param exclude string array properties to exclude from transformation
 * @returns transformation result
 */
export function toPascalCase(o: any, exclude?: Array<string>): any {
  if (typeof o == 'string') {
    return (o.charAt(0).toUpperCase() + o.slice(1)).toString();
  }

  let newO: IObjectKeys;
  var origKey, newKey, value;

  if (o instanceof Array) {
    return o.map(function (value) {
      if (typeof value === 'object') {
        value = toPascalCase(value, exclude);
      }
      return value;
    });
  } else {
    newO = {};
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        if (!exclude || exclude?.indexOf(origKey) < 0) {
          newKey = (origKey.charAt(0).toUpperCase() + origKey.slice(1) || origKey).toString();
        } else {
          newKey = origKey;
        }

        value = o[origKey];

        if (value instanceof Array || (value !== null && value !== undefined && value.constructor === Object)) {
          value = toPascalCase(value, exclude);
        }
        newO[newKey] = value;
      }
    }
  }

  return newO;
}
